<template>
    <div class="div">
        <button class="button is-small" :class="{'bold' : isFilled}" @click="closeModal" style="width: 55px;">
            {{ formatDate(carData.query.yard_pics) }}
        </button>
        <div class="modal is-small" :class="{'is-active': isActive }">
            <div class="modal-background" @click="closeModal"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Select date & upload pics</p>
                    <button class="delete" aria-label="close" @click="closeModal"></button>
                </header>
                <section class="modal-card-body">
                    <article v-if="error.status" class="message is-danger">
                        <div class="message-body">
                            <strong>{{ error.message }}!</strong>
                        </div>
                    </article>
                    <article v-if="success" class="message is-primary">
                        <div class="message-body">
                            <strong>File was successfully uploaded!</strong>
                        </div>
                    </article>
                    <div class="field">
                        <datetime
                                input-class="input"
                                v-model="carData.query.yard_pics"
                                :format="{ month: 'numeric', day: 'numeric'}"
                                type="date"
                                value-zone="local"
                                zone="local"
                                @close="selectDate"
                                :input-id="carData.id.toString()"
                                placeholder="Select date"
                        ></datetime>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-body">
                            <div class="field is-narrow">
                                <div class="file has-name is-boxed">
                                    <label class="file-label">
                                        <input class="file-input" multiple ref="images" v-on:change="handleImagesUpload" type="file">
                                        <span class="file-cta">
                                          <span class="file-icon">
                                            <i class="fas fa-upload"></i>
                                          </span>
                                          <span class="file-label">
                                            Choose a Image…
                                          </span>
                                        </span>
                                        <span class="file-name">
                                         <span v-for="image in images">{{ image.name }}, </span>
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="file has-name is-boxed">
                                    <label class="file-label">
                                        <input class="file-input" ref="video" v-on:change="handleVideosUpload" type="file">
                                        <span class="file-cta">
                                          <span class="file-icon">
                                            <i class="fas fa-upload"></i>
                                          </span>
                                          <span class="file-label">
                                            Choose a Video…
                                          </span>
                                        </span>
                                        <span class="file-name">
                                         <span>{{ video.name }}, </span>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <draggable v-model="uploaded.photos" :options="{group:'people'}" @start="drag=true" @end="drag=false" :move="enableSortButton">
                        <div v-for="element in uploaded.photos" :key="element" @dblclick="selectFile(element)" :class="{'is-focused': isSelected(element)}" class="button select-image">
                            <img class="fill" :src="element + '?' + new Date().getTime()">
                        </div>
                    </draggable>
                    <hr>
                    <div v-if="uploaded.video"  @dblclick="selectFile(uploaded.video)" :class="{'is-focused': isSelected(uploaded.video)}" class="button select-image">
                        <i class="fas fa-file-video"></i>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" @click="closeModal">Close</button>
                    <button class="button is-primary" @click="uploadPhotos" :class="{ 'is-loading': isLoading }">Upload Photos</button>
                    <button class="button is-primary" @click="uploadVideos" :class="{ 'is-loading': isLoading }">Upload Videos</button>
                    <button class="button" v-if="!mediaLoaded" @click="showUploadedFiles" :class="{ 'is-loading': isLoading }">Show Uploaded Files</button>
                    <button class="button is-info" v-if="enableSortBtn" @click="reorderMediaFiles" :class="{ 'is-loading': isLoading }">ReOrder Files</button>
                    <button class="button is-danger" v-if="readyToDelete" @click="deleteSelectedFiles" :class="{ 'is-loading': isLoading }"><i class="fas fa-trash-alt"></i></button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import apiCars from './../../../api/apiCars'
    import { Datetime } from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    import moment from 'moment'
    import draggable from 'vuedraggable'
    export default {
        props:['car'],
        components: {
            Datetime,
            draggable
        },
        data () {
            return {
                isActive: false,
                images: [
                    { name: 'Photos'}
                    ],
                video:
                    { name: 'Video'}
                ,
                carData:{
                    id: this.car.id,
                    query: {
                        yard_pics: this.car.yard_pics === null ? '---' : this.car.yard_pics,
                    }
                },
                error: {
                    status: false,
                    message: []
                },
                success: false,
                isLoading: false,
                uploaded: {
                    photos: [],
                    video: null
                },
                selectedFiles: [],
                enableSortBtn: false,
            }
        },
        computed: {
            isFilled() {
                if (this.formatDate(this.carData.query.yard_pics) !== '---'){
                    return  true;
                }
            },
            readyToDelete() {
                return this.selectedFiles.length > 0
            },
            mediaLoaded() {
                return this.uploaded.photos.length > 0
            }
        },
        methods: {
            closeModal() {
                this.isActive = !this.isActive
                this.uploaded.photos = []
                this.uploaded.video = null
            },
            enableSortButton() {
                this.enableSortBtn = true
            },
            selectDate(date) {
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.car.yard_pics = this.carData.query.yard_pics
                    })
                    .catch(error => console.log(error))
            },
            isSelected(file) {
                return this.selectedFiles.includes(file)
            },
            formatDate(date) {

                if(date){
                    return moment(date).format('M/D')
                }else{
                    return '---'
                }
            },
            handleImagesUpload(){
                this.images = this.$refs.images.files
            },
            handleVideosUpload(){
                this.video = this.$refs.video.files[0]
            },
            uploadPhotos() {
                this.isLoading = true
                this.success = false
                let formData = new FormData()

                formData.append('car_id',  this.car.id)

                for( var i = 0; i < this.images.length; i++ ){
                    let file = this.images[i]

                    formData.append('images[' + i + ']', file)
                }

                apiCars
                    .carsUploadPhotosRequest(formData)
                    .then((response) => {
                        this.images = [{ name: 'Photos'}]
                        this.success = true
                        this.error.status = false
                        this.isLoading = false
                    })
                    .catch(error => {
                        console.log(error)
                        if ( error.response && error.response.status === 422 ) {
                            this.error.status = true
                            this.error.message = 'The documents must be a file of type: peg, png, bmp, gif, or svg.'
                            this.isLoading = false
                        }
                    })
            },
            uploadVideos() {
                this.isLoading = true
                this.success = false
                let formData = new FormData()

                formData.append('car_id',  this.car.id)
                formData.append('video', this.video)


                apiCars
                    .carsUploadVideosRequest(formData)
                    .then((response) => {
                        this.video = [{ name: 'Video'}]
                        this.success = true
                        this.error.status = false
                        this.isLoading = false
                    })
                    .catch(error => {
                        console.log(error)
                        if ( error.response && error.response.status === 422 ) {
                            this.error.status = true
                            this.error.message = 'The documents must be a file of type: mov, avi, mp4.'
                            this.isLoading = false
                        }
                    })
            },
            showUploadedFiles() {
                this.error.status = false 
                this.isLoading = true
                this.success = false
                apiCars
                    .getCarMediaFilesRequest(this.car.id)
                    .then((response) => {
                        this.isLoading = false
                        this.uploaded.photos = response.data.photos
                        this.uploaded.video = response.data.video
                        console.log(response.data)
                    })
                    .catch(error => {
                        this.isLoading = false
                        if ( error.response && error.response.status === 404 ) {
                            this.error.status = true
                            this.error.message = error.response.data
                            this.isLoading = false
                        }
                        console.log(error)

                    })
            },
            selectFile(file) {
                if (this.selectedFiles.includes(file)) {
                    this.selectedFiles = this.selectedFiles.filter(item => item !== file)

                } else {
                    this.selectedFiles.push(file)
                }
            },
            deleteSelectedFiles() {
                this.error.status = false
                this.isLoading = true
                this.success = false
                let query = {
                    media: this.selectedFiles
                }
                apiCars
                    .deleteCarMediaFilesRequest(query)
                    .then((response) => {
                        this.isLoading = false
                        this.selectedFiles = []
                        this.showUploadedFiles()
                    })
                    .catch(error => {
                        this.selectedFiles = []
                        this.isLoading = false
                        console.log(error)

                    })
            },
            reorderMediaFiles() {
                this.error.status = false
                this.isLoading = true
                this.success = false
                let query = {
                    car_id: this.car.id,
                    media: this.uploaded.photos
                }
                apiCars
                    .reorderCarMediaFilesRequest(query)
                    .then((response) => {
                        this.isLoading = false
                        this.showUploadedFiles()
                        this.enableSortBtn = false
                    })
                    .catch(error => {
                        this.isLoading = false
                        console.log(error)

                    })
            }

        },
        mounted() {

        }
    }
</script>

<style scoped>
    .fill {
        object-fit: fill;
    }
    .select-image {
        height: 50px;
        width: 50px;
        margin-left: 5px;
        margin-bottom: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/YardPicsColumn.vue